import styles from './full-table.module.scss';
import { UseTableHook, useTableConfigHook } from '../requestUtils';
import WebkuaTable from '../webkua-table/webkua-table';
import { iTableSwitch } from '@frontend-workspace/react-shared-lib';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';


/* eslint-disable-next-line */
export interface FullTableProps {
  headers: any[],
  url: string,
  tableConfigName: string,
  expandComponent?: any,
  exandProps?: any,
  tableFilters?: iTableSwitch[],
  pageSize?: number,
  disableProductsFilter?: boolean,
  disableGroupFilter?: boolean,
  ignoreCompany?: boolean,
  initialStartDate?: Date,
  initialEndDate?: Date,
  supportFutureDates?: boolean,
  dataFilter?: (row: any) => any,
}

export function FullTable(props: FullTableProps) {

  const { t } = useTranslation();
  const { data, dateRange, forGroup, getData, isLoading, onDateChange, onForGroupToggle, productFilter } = UseTableHook(props.url, { supportForGroup: !props.disableGroupFilter, ignoreCompany: props.ignoreCompany, startDate: props.initialStartDate, endDate: props.initialEndDate });

  const tableFilters: iTableSwitch[] = props.disableGroupFilter ? [] : [{
    label: t("standard.showForGroup"),
    checked: forGroup,
    onChange: onForGroupToggle
  }];
  if (props.tableFilters) {
    tableFilters.push(...props.tableFilters);
  }

  const tableConfig = useTableConfigHook(props.tableConfigName);
  const filteredData = props.dataFilter ? data.filter(props.dataFilter) : data;
  const noData = data.length === 0 && !isLoading;
  return (
    !tableConfig.isLoading ? <WebkuaTable
      data={filteredData}
      dateRange={dateRange}
      supportFutureDates={props.supportFutureDates}
      isLoading={isLoading}
      productsFilter={props.disableProductsFilter ? undefined : productFilter}
      onSetDateRange={onDateChange}
      headers={props.headers}
      expandComponent={props.expandComponent}
      showNoDataAlert={noData}
      expandProps={props.exandProps}
      tableFilters={tableFilters}
      tableConfig={tableConfig}
      pageSize={props.pageSize}
      onRefresh={getData}
    /> : null
  );
}

export default FullTable;